import { inject } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { ReviewItemService } from '@examdojo/review';
import { map, of } from 'rxjs';

export function reviewActiveItemResolver() {
  const reviewItemService = inject(ReviewItemService);
  const errorHandlerService = inject(ErrorHandlerService);

  return reviewItemService.fetchActive().pipe(
    errorHandlerService.catchHttpErrors(() => of(null), { showErrorDetailsInToast: true }),
    map(() => true),
  );
}
